'use strict';

var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');
var Reflux = require('reflux');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./recently-viewed.scss');
}

var Store = require('../store').Store;

var Constants = require('../constants');
var Media = require('./media.jsx');
var Moma = require('../plugins/moma/');
var ResponsiveMixin = require('../global').ResponsiveMixin;

var RvGallery = React.createClass({
    mixins: [ Moma, ResponsiveMixin ],

    AssetSizes: function() {
        return {
            desktop: {
                width: Constants.Breaks.DesktopWidth,
                height: 138,
            },
            mobile: {
                portrait: {
                    width: 500,
                    height: 222,
                },
                landscape: {
                    width: 750,
                    height: 275,
                },
            },
        };
    },
    slideContent: function(slide, meta) {
        const height = meta ? meta.height : null;
        return (
            // TODO convert to <Link>
            <div key={slide.id}>
                <a href={slide.url}>
                    <Media media={slide} height={height} />
                </a>
            </div>
        );
    },
});

var RecentlyViewed = React.createClass({
    mixins: [
        Reflux.connect(Store, 'store'),
        Reflux.listenTo(Store, 'onStoreChange', 'onStoreChange')
    ],

    onStoreChange: function() {
        var items = _.reject(this.state.store.recentlyViewed, (item) => {
            var p = window.location.pathname;
            return (p == item.url || (item.alternateURL && p == item.alternateURL));  // alternateURL is for DYO - see design.jsx
        });
        this.setState({
            items: items,
        }, function() {
            if (this.refs.moma) {
                this.refs.moma.runLayoutCalculations();
                this.forceUpdate();
            }
        });
    },
    render: function() {
        if (!this.state.items || this.state.items.length == 0) {
            return <div className='recent-empty' />
        }

        const gallerySpec = {
            desktop: {
                position: 'outside',
                graphic: 'light',
                navigation: 'paged',
            },
        };

        return (
            <div className='recent'>
                <div className='recent-title'>
                    RECENTLY VIEWED
                </div>
                <RvGallery ref             = 'moma'
                           spec            = {gallerySpec}
                           gallery         = {this.state.items}
                           pageSize        = {0.7}
                           loop            = {false}
                           ident           = 'recent' />
            </div>
        );
    },
});

module.exports = RecentlyViewed;



// WEBPACK FOOTER //
// ./src/components/recently-viewed.jsx